export const BANNER_HEIGHT_VARIABLE = '--hop-banner-height'

const BANNER_HEIGHT = `var(${BANNER_HEIGHT_VARIABLE}, 0px)`

export const belowBanner = (gap: string) => `calc(${BANNER_HEIGHT} + ${gap})`

export const viewportHeightBelowBanner = (gap: string) => `calc(100vh - ${BANNER_HEIGHT} - 2 * ${gap})`
